import React, { useMemo } from "react";
import random from "lodash/random";

const ProductRowLoader = () => {
  const titleWidth = useMemo(() => random(2, 6) * 10, []);
  const descrWidth = useMemo(() => random(2, 6) * 10, []);

  return (
    <div className="ba bg-white br2 shadow-0 flex flex-column items-center relative overflow-hidden hairline-1 h-100 w-100">
      <div className="pa2 w-100">
        <div className={`h2 w-${titleWidth} shimmer self-start`}></div>
      </div>
      <div className="pa2 w-100">
        <div
          style={{ height: 20 }}
          className={`w-${descrWidth} shimmer self-start`}
        ></div>
      </div>
      <div className="flex flex-row items-center jusitfy-between w-100 bt hairline-1">
        <div className="pa2 flex w-100">
          <div style={{ height: 24 }} className="w2 shimmer self-start"></div>
        </div>
        <div className="pa2 flex">
          <div style={{ height: 24 }} className="w3 shimmer"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductRowLoader;
